import { Component, ViewChild } from '@angular/core';
import { Platform , Nav} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { TabsPage } from '../pages/tabs/tabs';
import { Home } from '../pages/home/home';
import { NgwService } from './ngw.service';
import { CreateNgwGamePage } from '../pages/CreateNgwGame/CreateNgwGame';
import { PastGames } from '../pages/pastGames/pastGames';
import { StarredStandings } from '../pages/starredStandings/starredStandings';
import { NgwGame } from './classes/NgwGame';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage:any = Home;
  pages: Array<{title: string, component: any}>
  games:NgwGame[]

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public ngwService: NgwService) {
    platform.ready().then(() => {
      
      
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      this.ngwService.getGamesWhenReady().then((value:NgwGame[]) => {
        this.games = value;
      });
      console.log("GAAAME", this.games)
    });

    this.pages = [
        { title: 'Home', component: Home },
        { title: 'Create New Game', component: CreateNgwGamePage },
          { title: 'List Past Games', component: PastGames },
        { title: 'Current Game', component: TabsPage }
      ];


      
  }

  areThereStarredGames() {
    let retVal:boolean = false;

    if(this.games)
    {
      if(this.games.filter((game) => (game.starred)).length > 0)
        retVal = true;
    }

    return retVal;
  }

openStarredStandings() {
  this.nav.push(StarredStandings);
}
  openGame(game) {
    this.ngwService.currentGame = game;
    this.nav.setRoot(TabsPage);
  }
  
   openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts